export const buscaPaises = (api, props, controller) => {
  return api.get(`pais`, {
    signal: controller.signal,
    params: props,
  });
};
